import { DrawerBody, Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useContractType } from '../hooks/useContractType';
import { useContractTypes } from '../hooks/useContractTypes';
import { useCreateContractModalContext } from '../modals/CreateContractModal/ModalContext';
import ContractModalFooter from '../molecules/ContractModalFooter';
import ContractTypeOptionsList from '../molecules/ContractTypeOptionsList';

interface ContractTypeOptionsProps {
  onClose: () => void;
  onNext?: (selectedType: string) => void;
}

const ContractTypeOptions: React.FC<ContractTypeOptionsProps> = ({
  onClose,
  onNext,
}) => {
  const { selectedType, handleTypeChange } = useContractType();
  const { nextStep, checkPeriodicityConflict, setSelectedContractType } =
    useCreateContractModalContext();
  const { contractTypes } = useContractTypes();
  const [loading, setLoading] = useState(false);

  const handleNext = async () => {
    if (!selectedType) {
      toast.error(`Necessário selecionar um tipo!`);
      return;
    }

    const selectedContractType = contractTypes.find(
      (contractType) => contractType.value === selectedType,
    );

    if (selectedContractType) {
      setLoading(true);
      try {
        if (await checkPeriodicityConflict(selectedContractType)) {
          toast.error(
            `Já existe um contrato ativo com restrição única nesta periodicidade.`,
          );
          return;
        }

        setSelectedContractType(selectedContractType);

        if (onNext) {
          onNext(selectedType);
        } else {
          nextStep();
        }
      } catch (e) {
        console.error('Erro ao verificar conflito de periodicidade', e);
        toast.error('Não foi possível verificar os contratos ativos');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Flex direction="column" flex={1} minH={0} overflow="hidden">
      <DrawerBody scrollBehavior="auto" pb="0" px={0} overflowX="hidden">
        <ContractTypeOptionsList
          selectedValue={selectedType}
          onValueChange={handleTypeChange}
        />
      </DrawerBody>
      <ContractModalFooter
        onCancel={onClose}
        onNext={handleNext}
        isNextDisabled={!selectedType || loading}
      />
    </Flex>
  );
};

export default ContractTypeOptions;
